const ReportSections = {
    DECISION_MODULE: 'decisionModule',
    INTELLECTUAL_CAPABILITY: 'intellectualCapability',
    INTELLECTUAL_CAPABILITY_EXTENDED: 'intellectualCapabilityExtended',
    INTELLECTUAL_CAPABILITY_MBO: 'intellectualCapabilityMbo',
    COMPETENCY_PROFILE: 'competencyProfile',
    HEXIT: 'hexit',
    ENQUIRY: 'enquiry',
    ABILITY_TO_CHANGE: 'abilityToChange',
    SELECTION_ADVICE: 'selectionAdvice',
    SELECTION_DEVELOPMENT_ADVICE: 'selectionDevelopmentAdvice',
    STRONG_POINTS: 'strongPoints',
    POINTS_OF_ATTENTION: 'pointsOfAttention',
    DEVELOPMENT_ADVICE: 'developmentAdvice',
    PERSONALITY: 'personality',
    WORKING_STYLES: 'workingStyles',
    WPQ: 'wpq',
    RESEARCH_QUESTION: 'researchQuestion',
    INFLUENCING_STYLES: 'influencingStyles',
    MOTIVES: 'motives',
    ABOUT_REPORT: 'aboutThisReport',
    TEAM_ROLES_DEVELOPMENT: 'teamRolesDevelopment',
    TEAM_ROLES: 'teamRoles',
    RISK_INDICATION: 'riskIndication',
    PERSONALITY_BUILDING_DOCKS: 'personalityBuildingDocks',
    REFLECTION: 'reflection',
    WORK_ENVIRONMENT: 'workEnvironment',
    ABILITY_TO_CHANGE_CALCULATED: 'abilityToChangeCalculated',
    QUALITIES: 'qualities',
    REFLECTION_WITH_EXERCISES: 'reflectionWithExercises',
    COLLABORATION: 'collaboration',
    WORK_APPROACH: 'workApproach',
    FLEXIBILITY_TO_CHANGE: 'flexibilityToChange',
    DEALING_WITH_RESISTANCE: 'dealingWithResistance',
    WORK_SAFELY: 'workSafely',
    CRITICAL_THINKING: 'criticalThinking',
    LSR_CONCLUSION: 'lsrConclusion'
};

export default ReportSections;
